// Errors
import { ArgumentNullError } from "@ms/uno-errors/lib/local/errors";
import { RecurrenceCalculator } from "./RecurrenceCalculator";
// Utilities
import { Temporal } from "temporal-polyfill-lite";
import flatten from "lodash/flatten";
import { getDaysOrDates } from "../utilities/DayOrDateUtilities";
/**
 * Represents a recurrence calculator with multiple day or date objects.
 * @example Fourth Thursday of November.
 * @example Every Monday and Thursday of every other week.
 */ export class MultipleDaysOrDatesRecurrenceCalculator extends RecurrenceCalculator {
    calculateOccurrencesBetween(start, end) {
        start = this.offsetStart(start);
        const datesForPeriods = this.getPeriodsBetween(start, end).map((period)=>this.daysOrDates.map((dayOrDate)=>dayOrDate.resolveDateForPeriod(period)));
        const allDates = flatten(datesForPeriods);
        return allDates.filter((period)=>Temporal.PlainDate.compare(period, start) >= 0 && Temporal.PlainDate.compare(period, end) <= 0 && this.getDurationBetweenDateAndPatternStartDate(period) % this.interval === 0)// Sorting to get the dates in order. This is because dayOrDates is not guaranteed to be in order.
        .sort((a, b)=>Temporal.PlainDate.compare(a, b) < 0 ? -1 : 1);
    }
    offsetStart(start) {
        let startOffset = Temporal.PlainDate.from(start);
        /** OPTIMIZATION BELOW: Remove all days before pattern start date */ if (Temporal.PlainDate.compare(start, this.patternStartDate) <= 0) {
            startOffset = Temporal.PlainDate.from(this.patternStartDate);
        }
        return startOffset;
    }
    constructor(schedule, patternStartDateAsInstant, occurrenceIndex, periodPattern){
        super(schedule, patternStartDateAsInstant, occurrenceIndex, periodPattern);
        const daysOrDates = getDaysOrDates(schedule.pattern);
        if (daysOrDates == null) {
            throw new ArgumentNullError("Invalid recurrence pattern");
        }
        this.daysOrDates = daysOrDates;
    }
}
